import {css} from "lit";
export const style = css`

  :host {
    --list-color: var(--_list-color, var(--sbkTextListFgColorOnLightEnabled));
    --list-checkmark__icon: var(--_list-checkmark__icon, url("data:image/svg+xml,%3Csvg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0 0 24 24'%3E%3Cdefs%3E%3Cstyle%3E .cls-1 %7B fill: %23003c6e; stroke-width: 0px; %7D %3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M19.3,8.7l-8.3,8.4c-.2.2-.5.4-.9.3-.3,0-.6-.1-.9-.3l-4.6-4.7c-.5-.5-.5-1.2,0-1.7.5-.5,1.2-.5,1.7,0l3.8,3.9,7.5-7.5c.5-.5,1.2-.5,1.7,0,.5.5.5,1.2,0,1.7Z'/%3E%3C/svg%3E"));
    --list-disc__icon: '•';
  }

  .list {
    color:  var(--list-color);
    padding: 0;
    max-width: var(--sbkCoreContentAreaBodyMaxWidth);
  }

  .list--none{
    list-style: none;
    margin: 0;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style-type: var(--sbkTextListMarkerTypeDis);
  }

  .list--checkmark {
    list-style: none;
    margin-left: 0;
  }

  ol {
    list-style-type: none;
  }
`;